/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  iconColors,
  iconSizes,
} from '@backmarket/design-system/components/Icon/Icon.constant'
import { type IconName, iconNames } from '@backmarket/design-system/icons/icons'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import type { IconColor, IconSize } from '@ds/types/Icon'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type CmsIcon = {
  technicalName?: Maybe<string>
  icon: IconName
  color?: Maybe<IconColor>
  size?: Maybe<IconSize>
}

/* Schemas */
export const IconNameSchema = z.enum(iconNames)

export const IconColorSchema = z.enum(iconColors)

export const IconSizeSchema = z.enum(iconSizes)

export const CmsIconSchema = z.object({
  technicalName: z.nullish(z.string()),
  icon: IconNameSchema,
  color: z.nullish(IconColorSchema),
  size: z.nullish(IconSizeSchema),
})

/* Schemas validation */
type TestCmsIcon = ExpectTrue<Equal<CmsIcon, z.infer<typeof CmsIconSchema>>>
